import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'eos-guest-layout',
  templateUrl: './guest-layout.component.html'
})
export class GuestLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
